import axios from 'axios'
import qs from 'qs'

// 创建axios实例
const request = axios.create({
  baseURL: '', // 使用代理URL
  timeout: 15000, // 请求超时时间
  withCredentials: false, // 跨域时不携带cookie，避免CORS复杂度
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 判断是否使用JSON格式 (可以通过config.useJson或者config.data._useJson来判断)
    const useJson = config.useJson || (config.data && config.data._useJson);
    
    // 设置合适的Content-Type
    if (useJson) {
      config.headers['Content-Type'] = 'application/json';
      // 如果有_useJson标记，需要从数据中删除
      if (config.data && config.data._useJson !== undefined) {
        delete config.data._useJson;
      }
    } else {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      // 将POST请求数据转换为表单格式
      if (config.method === 'post' && config.data) {
        config.data = qs.stringify(config.data);
      }
    }
    
    // 生产环境处理maker请求
    if (process.env.NODE_ENV === 'production' && config.url.startsWith('/maker/')) {
      // 替换域名和移除 maker 前缀
      config.url = config.url.replace('/maker', '')
      config.baseURL = 'https://logoapi.logogou.cn'
      // 跨域请求不携带凭证
      config.withCredentials = false
    }
    
    // 处理aigene请求 - 走特定域名
    if (config.url.startsWith('/api/aigene')) {
      config.url = config.url.replace('/api', '')
      
      // 开发环境使用代理，生产环境直接请求
      if (process.env.NODE_ENV === 'development') {
        // 开发环境：使用代理，可以携带cookie
        config.baseURL = ''
        config.withCredentials = true
      } else {
        // 生产环境：直接请求aiapi域名
        config.baseURL = 'https://aiapi.logogou.com'
        config.withCredentials = true
      }
      
      // 从cookie中提取认证信息并添加到请求头（解决跨子域名cookie问题）
      const cookies = document.cookie.split(';')
      let sid = '', uuid = ''
      
      cookies.forEach(cookie => {
        const [name, value] = cookie.trim().split('=')
        if (name === 'sid') sid = value
        if (name === 'uuid') uuid = value
      })
      
      // 将认证信息添加到请求头（使用标准请求头避免CORS预检）
      if (sid) config.headers['Authorization'] = `Bearer ${sid}`
      if (uuid) config.headers['X-User-ID'] = uuid
    }
    
    // 不要设置Referrer策略，让浏览器自动处理
    // config.headers['Referrer-Policy'] = 'no-referrer-when-downgrade';
    
    console.log('发送请求:', config.url, config.data, '使用JSON:', useJson);
    return config;
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(

  response => {
    console.log('收到响应:', response.config.url, response.data);
    return response
  },
  error => {
    // 详细记录错误信息
    console.error('API请求错误:', error);
    if (error.response) {
      // 服务器返回了错误状态码
      console.error('错误状态:', error.response.status);
      console.error('错误数据:', error.response.data);
      console.error('错误头信息:', error.response.headers);
    } else if (error.request) {
      // 请求已发送但没有收到响应
      console.error('没有收到响应:', error.request);
    } else {
      // 请求配置有误
      console.error('请求配置错误:', error.message);
    }
    
    // 处理跨域错误
    if (error.message.includes('Network Error') || error.message.includes('CORS')) {
      console.log('跨域请求被阻止，请确认代理服务器配置正确');
    }
    return Promise.reject(error)
  }
)

// API函数 - 使用表单格式
export const logoSearchApi = (data) => {
  return request({
    url: '/api/gene/logo_goods_list',
    method: 'POST',
    data
  })
}
// API函数 - 使用表单格式
export const GetMyselfInfoApi = (data) => {
  return request({
    url: '/api/server/get_myself_info',
    method: 'POST',
    data
  })
}
// API函数 - 使用JSON格式
export const loginApi = (data) => {
  return request({
    url: '/api/server/login',
    method: 'POST',
    data,
    useJson: true // 标记使用JSON格式
  })
}
// API函数 - 使用JSON格式
export const SendVerifycodeApi = (data) => {
  return request({
    url: '/api/server/send_verifycode',
    method: 'POST',
    data,
    useJson: true // 标记使用JSON格式
  })
}

// API函数 - 使用JSON格式
export const logoSearchJsonApi = (data) => {
  return request({
    url: '/maker/gene/logo_goods_list',
    method: 'POST',
    data,
    useJson: true // 标记使用JSON格式
  })
}
// 获取logo详情
export const logoUpdateTextApi = (data) => {
  return request({
    url: '/maker/gene/logo_update_text',
    method: 'POST',
    data,
    useJson: true // 标记使用JSON格式
  })
}


// 获取logo详情
export const logoDetailApi = (data) => {
  return request({
    url: '/maker/gene/logo_details',
    method: 'POST',
    data,
    useJson: true // 标记使用JSON格式
  })
}

// 获取logo详情
export const getExampleApi = (data) => {
  return request({
    url: '/api/aigene/logo_examples',
    method: 'POST',
    data,
    useJson: true // 标记使用JSON格式
  })
}

// 获取logo详情
export const changeGoodsApi = (data) => {
  return request({
    url: '/maker/gene/goods_change',
    method: 'GET',
    params: data  // 改用 params 而不是 data
  })
}


// 收藏按钮
export const logoCollectApi = (data) => {
  return request({
    url: '/api/server/logo_set_collect',
    method: 'POST',
    data,
    useJson: true // 标记使用JSON格式
  })
}
// 查询收藏
export const logoGetCollectApi = (data) => {
  return request({
    url: '/api/server/logo_get_collect',
    method: 'POST',
    data,
    useJson: true // 标记使用JSON格式
  })
}

export const logoSetAllViewApi = (data) => {
  return request({
    url: '/api/server/set_all_view',
    method: 'POST',
    data
  })
}

export const isLoginApi = () => {
  return request({
    url: '/api/server/is_login',
    method: 'POST'
  })
}
export const logoCreateOrderApi = (data) => {
  return request({
    url: '/api/server/logo_create_order',
    method: 'POST',
    data,
    useJson: true // 标记使用JSON格式
  })
}

export const createTransactionApi = (data) => {
  return request({
    url: '/api/server/create_transaction',
    method: 'POST',
    data,
    useJson: true // 标记使用JSON格式
  })
}
export const payApi = (data) => {
  return request({
    url: '/api/pay.esp?create_pay',
    method: 'POST',
    data,
    useJson: true // 标记使用JSON格式
  })
}
export const queryPayApi = (data) => {
  return request({
      url: '/api/pay.esp?query_pay',
      method: 'POST',
      data,
      useJson: true // 标记使用JSON格式
  })
}

export const wxPayApi = (data) => {
  return request({
      url: '/api/pay.esp?create_wx_pay',
      method: 'POST',
      data,
      useJson: true // 标记使用JSON格式
  })
}
export const wxQueryPayApi = (data) => {
  return request({
      url: '/api/pay.esp?query_wx_pay',
      method: 'POST',
      data,
      useJson: true // 标记使用JSON格式
  })
}

// AI生成Logo接口
export const generateAILogoApi = (data) => {
  return request({
    url: '/api/aigene/text_genere_logo',
    method: 'POST',
    data,
    useJson: true // 标记使用JSON格式
  })
}

// 查询AI生成任务状态接口
export const queryAILogoTaskApi = (data) => {
  return request({
    url: '/api/aigene/get_result',
    method: 'POST',
    data,
    useJson: true // 标记使用JSON格式
  })
}
// 根据品牌名和行业生成图标描述
export const LogodescApi = (data) => {
  return request({
    url: '/api/aigene/logo_desc',
    method: 'POST',
    data,
    useJson: true // 标记使用JSON格式
  })
}

/**
 * 构建生成文本描述
 * @param {Object} formData 表单数据
 * @param {Array} selectedIndustryNames 选中的行业名称数组
 * @param {string} logoType Logo类型
 * @returns {string} 生成的文本描述
 */
export const buildGenerateText = (formData, selectedIndustryNames, logoType) => {
  let text = ''
  
  // 基础信息
  if (formData.brandName) {
    text += `${formData.brandName} logo设计`
  }
  
  // 副标题
  if (formData.slogan) {
    text += `，标语：${formData.slogan}`
  }
  
  // 行业信息 - 直接使用传入的行业名称
  if (selectedIndustryNames.length > 0) {
    text += `，行业：${selectedIndustryNames.join('、')}`
  }
  
  // Logo类型
  if (logoType === 'graphic') {
    text += '，图形logo'
  } else if (logoType === 'text') {
    text += '，文字logo'
  }
  
  // 风格描述
  if (formData.style && formData.style !== 'any') {
    const styleMap = {
      'pixel': '像素风',
      '故障艺术': '故障艺术',
      '复古': '复古',
      '简约': '简约',
      'flat': '扁平',
      '卡通': '卡通'
    }
    text += `，${styleMap[formData.style] || formData.style}风格`
  }
  
  // 自定义描述
  if (formData.description) {
    text += `，${formData.description}`
  }
  
  return text
}

// 图片处理和SVG转换接口（合并）
export const svgConvertApi = (data) => {
  return request({
    url: '/api/aigene/svg_convert',
    method: 'POST',
    data,
    useJson: true
  })
}

// 生成模板接口
export const generateTemplateApi = (data) => {
  return request({
    url: '/api/aigene/genere_tpl',
    method: 'POST',
    data,
    useJson: true
  })
}

// Logo示例接口
export const getLogoExamplesApi = (data) => {
  return request({
    url: '/api/aigene/logo_examples',
    method: 'POST',
    data,
    useJson: true
  })
}

// VIP套餐相关接口
export const getVipPackagesApi = (data) => {
  return request({
    url: '/api/server/vip_packages_list',
    method: 'POST',
    data
  })
}

// 充值豆豆套餐接口
export const getRechargePackagesApi = (data) => {
  return request({
    url: '/api/server/points_packages_list',
    method: 'POST',
    data
  })
}

// VIP订单创建接口
export const vipCreateOrderApi = (data) => {
  return request({
    url: '/api/server/vip_create_order',
    method: 'POST',
    data,
    useJson: true // 标记使用JSON格式
  })
}

// 积分订单创建接口
export const pointsCreateOrderApi = (data) => {
  return request({
    url: '/api/server/points_create_order',
    method: 'POST',
    data,
    useJson: true // 标记使用JSON格式
  })
}

// 获取设计师案例接口
export const getDesignExamplesApi = (data) => {
  return request({
    url: '/api/aigene/ailogo_examples',
    method: 'POST',
    data,
    useJson: true // 标记使用JSON格式
  })
}

// AI Logo历史记录接口
export const getHistoryRecordsApi = (data) => {
  return request({
    url: '/api/aigene/ailogo_historical_records',
    method: 'POST',
    data,
    useJson: true // 标记使用JSON格式
  })
}

// 生成普通文字接口
export const generateTextApi = (data) => {
  return request({
    url: '/api/aigene/generate-text',
    method: 'POST',
    data,
    useJson: true // 标记使用JSON格式
  })
}

// 生成弧形文字接口
export const generateArcTextApi = (data) => {
  return request({
    url: '/api/aigene/generate-arc-text',
    method: 'POST',
    data,
    useJson: true // 标记使用JSON格式
  })
}

// 获取模板JSON接口
export const getTemplateJsonApi = (data) => {
  return request({
    url: '/api/aigene/tpl_json',
    method: 'POST',
    data,
    useJson: true // 标记使用JSON格式
  })
}
// 编辑模板JSON接口
export const EditTemplateJsonApi = (data) => {
  return request({
    url: '/api/aigene/edit_tpl_json',
    method: 'POST',
    data,
    useJson: true // 标记使用JSON格式
  })
}
// 获取排版列表接口
export const getLayoutListApi = (data) => {
  return request({
    url: '/api/aigene/genere_tpl_change',
    method: 'POST',
    data,
    useJson: true // 标记使用JSON格式
  })
}

// 更换模板接口 (保留原有的，以防其他地方使用)
export const changeTemplateApi = (data) => {
  return request({
    url: '/api/aigene/genere_tpl_change',
    method: 'POST',
    data,
    useJson: true // 标记使用JSON格式
  })
}
//访问追踪
export const visitApi = (data) => {
  return request({
      url: '/apiTracking/v1/visit',
      method: 'POST',
      data,
      useJson: true // 标记使用JSON格式
  })
}
//转化追踪
export const conversionApi = (data) => {
  return request({
      url: '/apiTracking/v1/conversion',
      method: 'POST',
      data,
      useJson: true // 标记使用JSON格式
  })
}
//行为追踪
export const behaviorApi = (data) => {
  return request({
      url: '/apiTracking/v1/behavior',
      method: 'POST',
      data,
      useJson: true // 标记使用JSON格式
  })
}


export default request 